import { Flex, Heading, Separator } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';

import CreateBusinessPromo from '@features/navigation/CreateBusinessPromo';
import ModePicker from '@features/navigation/ModePicker';
import OrgPicker from '@features/navigation/OrgPicker';
import { PageNavigation } from '@features/navigation/PageNavigation';
import { NAVIGATION_TOP_BAR_HEIGHT_PX } from 'config/layout/navigationPanel';
import { toPxString } from 'helpers/styles';
import { useOrgSlug } from 'hooks/useOrgSlug';
import { useOrgStore } from 'stores/rootStore';

const NavigationSidebarContents = () => {
  const orgSlug = useOrgSlug();
  const isOrgPickerVisible = orgSlug != null;
  const orgStore = useOrgStore();
  const isCreatePromoVisible = orgStore.orgs.length === 0;

  return (
    <Flex flexDirection="column" h="full">
      <Flex
        justifyContent="space-between"
        alignItems="center"
        gap={2}
        mx={2}
        h={toPxString(NAVIGATION_TOP_BAR_HEIGHT_PX)}
      >
        <Heading userSelect="none">nullifyrisk</Heading>
      </Flex>
      <Flex flexDirection="column" h="full" gap={2}>
        {!isOrgPickerVisible && <Separator borderColor="sidebar.hover" visibility="hidden" />}
        {isOrgPickerVisible && (
          <Flex
            flexDirection="column"
            gap={2}
            p={2}
            w="full"
            borderTopColor="sidebar.hover"
            borderBottomColor="sidebar.hover"
            borderBottomWidth={1}
          >
            <OrgPicker />
            <ModePicker />
          </Flex>
        )}
        <Flex flex="1 1" flexDirection="column">
          <PageNavigation />
        </Flex>
        {isCreatePromoVisible && <CreateBusinessPromo />}
      </Flex>
    </Flex>
  );
};

export default observer(NavigationSidebarContents);
